import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Families() {
  const { t } = useTranslation();

  const supportAreas = [
    {
      icon: 'ri-home-heart-line',
      title: t('families_support1_title'),
      description: t('families_support1_desc')
    },
    {
      icon: 'ri-brain-line',
      title: t('families_support2_title'),
      description: t('families_support2_desc')
    },
    {
      icon: 'ri-message-3-line',
      title: t('families_support3_title'),
      description: t('families_support3_desc')
    },
    {
      icon: 'ri-heart-line',
      title: t('families_support4_title'),
      description: t('families_support4_desc')
    },
    {
      icon: 'ri-user-heart-line',
      title: t('families_support5_title'),
      description: t('families_support5_desc')
    },
    {
      icon: 'ri-community-line',
      title: t('families_support6_title'),
      description: t('families_support6_desc')
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center mt-16">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/e7605311edff4188dbd664db0f9809d3/83aff269a85754677faf3a384b596eaf.png"
            alt="Ukrainian military family walking together"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
        </div>

        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-medium mb-4">{t('families_hero_title')}</h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            {t('families_hero_subtitle')}
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('families_ripple_title')}</h2>
          <p className="text-lg text-stone-600 leading-relaxed mb-8">
            {t('families_ripple_p1')}
          </p>
          <p className="text-lg text-stone-600 leading-relaxed">
            {t('families_ripple_p2')}
          </p>
        </div>
      </section>

      {/* Support Areas Grid */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-medium text-stone-800 text-center mb-16">{t('families_support_title')}</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {supportAreas.map((area, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="w-14 h-14 bg-amber-500/10 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${area.icon} text-2xl text-amber-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-stone-800 mb-3">{area.title}</h3>
                <p className="text-stone-600 leading-relaxed">{area.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Family Stories Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('families_journey_title')}</h2>
            <p className="text-lg text-stone-600 leading-relaxed">
              {t('families_journey_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-stone-50 rounded-lg p-6">
              <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center mb-4">
                <i className="ri-parent-line text-xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-3">{t('families_partners_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('families_partners_desc')}
              </p>
            </div>

            <div className="bg-stone-50 rounded-lg p-6">
              <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center mb-4">
                <i className="ri-emotion-happy-line text-xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-3">{t('families_children_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('families_children_desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-medium mb-6">{t('families_cta_title')}</h2>
          <p className="text-lg text-stone-300 leading-relaxed mb-8 max-w-2xl mx-auto">
            {t('families_cta_desc')}
          </p>
          <a
            href="/contact"
            className="inline-block bg-white text-stone-800 px-8 py-4 rounded-full font-medium hover:bg-amber-500 hover:text-white transition-colors duration-300 whitespace-nowrap"
          >
            {t('families_cta_button')}
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}